import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import {
    fetchReportReasons,
    PostContentReport,
    PostUserReport
} from '../api/savedcontentApi'

export const useReportReasons = (options = {}) => {
    return useQuery({
        queryKey: ['GET_REPORT_REASONS'],
        queryFn: async () => {
            const resp = await fetchReportReasons()
            const data = resp?.data || resp
            return {
                reasons: data?.report_reasons || data?.reasons || (Array.isArray(data) ? data : [])
            }
        },
        ...options
    })
}

export const usePostContentReport = (options = {}) => {
    return useMutation({
        mutationKey: ['POST_REPORT'],
        mutationFn: async ({
            content_id,
            reason_for_report,
            reason
        }) => {
            return await PostContentReport(
                content_id,
                reason_for_report,
                reason
            )
        },
        ...options
    })
}

export const usePostUserReport = (options = {}) => {
    return useMutation({
        mutationKey: ['POST_USER_REPORT'],
        mutationFn: async ({ reported_user_id, reason }) => {
            return await PostUserReport(reported_user_id, reason)
        },
        ...options
    })
}
